const maskSensitiveData = (data: Record<string, any>): Record<string, any> => {
  const masked = { ...data };
  const sensitiveFields = ['phone', 'email', 'whatsapp', 'password', 'token', 'apiKey', 'api_key'];
  sensitiveFields.forEach(field => {
    if (masked[field]) {
      const value = String(masked[field]);
      masked[field] = value.length > 4 ? value.substring(0, 2) + '***' + value.substring(value.length - 2) : '***';
    }
  });
  return masked;
};

export interface StructuredLog {
  timestamp: string;
  level: 'debug' | 'info' | 'warn' | 'error';
  context: {
    page?: string;
    action?: string;
    userId?: string;
    component?: string;
  };
  message: string;
  data?: Record<string, any>;
}

const createLogEntry = (level: StructuredLog['level'], message: string, data?: Record<string, any>, context?: Partial<StructuredLog['context']>): StructuredLog => ({
  timestamp: new Date().toISOString(),
  level,
  context: { page: window.location.pathname + window.location.search, ...context },
  message,
  data: data ? maskSensitiveData(data) : undefined,
});

export const logger = {
  debug: (message: string, data?: Record<string, any>, context?: Partial<StructuredLog['context']>) => {
    if (import.meta.env.DEV) {
      const log = createLogEntry('debug', message, data, context);
      console.log(`[${log.context.page || 'app'}] ${message}`, data || '');
    }
  },
  info: (message: string, data?: Record<string, any>) => {
    const log = createLogEntry('info', message, data);
    console.info(`[INFO] ${message}`, data || '');
  },
  warn: (message: string, data?: Record<string, any>) => {
    const log = createLogEntry('warn', message, data);
    console.warn(`[WARN] ${message}`, data || '');
  },
  error: (message: string, error?: Error, data?: Record<string, any>) => {
    const log = createLogEntry('error', message, data);
    console.error(`[ERROR] ${message}`, error || '', data || '');
  },
};

export default logger;
